import { type FC } from 'react';

import {
    useFillPathway,
    useFillPrescription,
} from '../../../../contexts/fill/use-fill-prescription';
import { useDrugKey } from '../../../../hooks/use-drug-key';
import { useFlags } from '../../../../hooks/use-flags';
import { usePriceCardContent } from '../../../../hooks/use-price-card-content-props';
import type { PriceCardV2Flag } from '../../../../types/non-boolean-flags';
import { GovernmentPricing } from '../government/GovernmentPricing';
import { InsurancePricing } from '../insurance/InsurancePricing';
import { SelfPayPricing } from '../self-pay/SelfPayPricing';

import { PricingCardV2 } from './PricingCardV2';
import type { PricingCardProps } from './shared';

export const PricingCard: FC<PricingCardProps> = ({ offer }) => {
    const { pathway } = useFillPathway();
    const { enablePriceCardV2 } = useFlags();

    const { medication } = useFillPrescription();
    const drugKey = useDrugKey(medication);

    const priceCardFlag = enablePriceCardV2 as PriceCardV2Flag;

    const cardContentOverride = usePriceCardContent({
        medication,
        headlinePriceType: offer?.headlinePriceType,
        patientCost: offer?.patientCost,
    });

    if (
        !!drugKey &&
        priceCardFlag.drugKeys.includes(drugKey) &&
        cardContentOverride?.pricingCard
    ) {
        return (
            <PricingCardV2
                pricingCard={cardContentOverride.pricingCard}
                priceNote={cardContentOverride.priceNote}
            />
        );
    }

    switch (pathway) {
        case 'insurance':
            return <InsurancePricing offer={offer} />;
        case 'government':
            return <GovernmentPricing offer={offer} />;
        case 'fallback':
        case 'self-pay':
            return <SelfPayPricing offer={offer} />;
    }

    return <></>;
};
